/* tslint:disable: no-duplicate-imports */
import Quantity from './Quantity';

export * from './Quantity.props';

export {
    Quantity
};
